import React, { PropsWithChildren } from 'react';
import { QueryClient } from '@tanstack/react-query';

import { SentryContextProvider } from '../sentry/context';
import { UserLoader } from './user-loader';
import { GlobalProvider } from './global-provider';
import { ConfigLoader } from './config-loader';
import { GlobalServices } from '../global-services';
import { StrategyLoader } from './strategy-loader';
import { UserPreferencesLoader } from './user-preferences-loader';
import { FeatureFlagProvider } from '../feature-flag/context';

type ApplicationBootstrapProps = {
  services: GlobalServices;
  queryClient: QueryClient;
}

export function ApplicationBootstrap({ children, queryClient, services }: PropsWithChildren<ApplicationBootstrapProps>) {
  return (
    <React.StrictMode>
      <GlobalProvider queryClient={queryClient} services={services}>
        <ConfigLoader>
          <SentryContextProvider>
            <UserLoader>
              <FeatureFlagProvider>
                <UserPreferencesLoader>
                  <StrategyLoader>
                    { children }
                  </StrategyLoader>
                </UserPreferencesLoader>
              </FeatureFlagProvider>
            </UserLoader>
          </SentryContextProvider>
        </ConfigLoader>
      </GlobalProvider>
    </React.StrictMode>
  );
}
